import styles from "../Sections/Sections.module.css";
import markCompleteStyles from "../MarkAsCompleteHeader/MarkAsCompleteHeader.module.css";
import { ProgressBar } from "@shopify/polaris";
import {useSelector} from "react-redux";
import SubmitAllDocumentsHeader from "../SubmitAllDocumentsHeader/SubmitAllDocumentsHeader";
import {userIsDocCollector} from "../../helpers/users";

interface Props {
    surveyorCompletionStatus: any;
    dueDate: any;
    openModal: () => void;
}

export default function SubmissionProgressHeader({
    surveyorCompletionStatus,
    dueDate,
    openModal
}: Props) {
    const progressIncrement = 25;
    let progress = 0;
    let sectionsComplete = 0;
    const isDocumentCollector: boolean = useSelector((state: any) => userIsDocCollector(state));

    if (surveyorCompletionStatus) {
        if (surveyorCompletionStatus.ChecklistComplete) {
            sectionsComplete++;
            progress += progressIncrement;
        }

        if (surveyorCompletionStatus.PhotosComplete) {
            sectionsComplete++;
            progress += progressIncrement;
        }

        if (surveyorCompletionStatus.DocumentsComplete) {
            sectionsComplete++;
            progress += progressIncrement;
        }

        if (surveyorCompletionStatus.CarbonSectionComplete) {
            sectionsComplete++;
            progress += progressIncrement;
        }
    }

    if (progress === 99) {
        progress = 100;
    }

    return (
        <div>
            {
                isDocumentCollector ?
                    <SubmitAllDocumentsHeader openModal={openModal}/>
                :
                <div>
                    <div className={markCompleteStyles.markAsCompleteHeader}>
                        <div className={styles.submissionDate}>
                            Submission Deadline: {dueDate}
                        </div>
                        <div className={styles.progressBar}>
                            <ProgressBar progress={progress} size={"small"} />
                                <div className={styles.sectionsComplete}>
                                    {sectionsComplete}/4 Sections Complete
                                </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}
